import chartCard from "@/components/common/chart-card";
import dateField from "@/components/common/date-field";

export default {
  name: "FiancialView",
  components: {
    chartCard,
    dateField
  },
  data() {
    return {
      pageName: 'Visualização Financeira',
      monthToName: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dec", "13º"],

      countFilter: 0,
      filter: this.FilterDefault(),
      loading: false,
      loadingReport: false,

      itemList: [],
      chartOptionsMoney: {
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return this.filterCurrency(tooltipItem.yLabel);
            }.bind({filterCurrency: this.$options.filters.currency})
          },
        },
        scales: {
          yAxes: [{
            ticks: {
              callback: function(value, index, values) {
                return this.filterCurrency(value);
              }.bind({filterCurrency: this.$options.filters.currency})
            }
          }]
        }
      },

      chartFields: {
        AmountIncome: {
          name: "Renda",
          type: "money"
        },
        Quantity:{
          name: "Quantidade",
          type: "number"
        },
        Amount:{
          name: "Volume Transacionado",
          type: "money"
        }
      },
      chartList: []
    };
  },

  mounted() {
    this.ListIncome();
  },

  watch: {
    itemList(newVal){
      Object.entries(this.chartFields).forEach(([key, chartField], index) => {
        this.chartList[index] = {
          name: chartField.name,
          field: key,
          options: chartField.type == "money" ? this.chartOptionsMoney : {},
          chart: this.GenerateChart(newVal, key)
        }
      });
    }
  },

  methods: {
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    FilterDefault(){
      return {
        Type: "M",
        Date: this.$options.filters.date(new Date(new Date().getFullYear(), 0, 1), "YYYY-MM-DD")
      }
    },

    ResetFilter() {
      this.filter = this.FilterDefault();
      this.ListIncome();
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListIncome();
    },

    GenerateChart(itemList, field = "AmountIncome"){
      //labels => Horizontal chart text
      //dataset.label => Label fom each line
      //dataset.data[] => Each elapsed value on the chart
      //                  x = Horizontal, y = Vertical
      const labels = [];
      const datasets = itemList.map((elem, i) => {
        //Define the labels (Horizontal chart text) using the last possible month
        elem.IncomeValues.map(
          income => {
            const tempLabel = this.monthToName[income.Month - 1];
            if(!labels.includes(tempLabel)){
              labels.push(tempLabel);
            }
          }
        );

        //If the income has started middle year, then the previous months are filled with 0
        //If this is not done, the chart for month 9 starts on position 0 (January) (position != month)
        const firstIncomeMonth = Math.min(...elem.IncomeValues.map(income => income.Month));
        const chartMonthFiller = [];
        for(let i = 1; i < firstIncomeMonth; i++) {
          chartMonthFiller.push({x: i-1, y: 0});
        }

        return {
          label: elem.PaymentMethod.Name,
          borderColor: this.GetDataBorderColor(i + 1),
          backgroundColor: this.GetDataColor(i + 1),
          data: [...chartMonthFiller, ...elem.IncomeValues.map(income => ({x: income.Month - 1, y: income[field]}))]
        }
      });

      return {
        labels: labels,
        datasets: datasets
      }
    },

    ReportIncome(field = 'All'){
      this.loadingReport = true;
      this.$store.dispatch("ReportIncome", {...this.filter, ReportType: field})
      .then(response => {
        if (response.UrlReport) {
          this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
          window.open(response.UrlReport, "_self");
        }else{
          this.$makeToast("Não foi possivel gerar o relatório", "danger", "Relatório indisponível");
        }
      })
      .catch(error => {
        this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
      })
      .finally(() => {
        setTimeout(() => {
          this.loadingReport = false;
        }, 1200);
      });
    },

    ListIncome() {
      this.chartList = [];
      this.loading = true;
      Object.values(this.filter).map(value => { if (value) this.countFilter++ });
      this.$store.dispatch("ListIncome", this.filter)
        .then(response => {
          this.itemList = response;
        })
        .catch(error => {
          this.$makeToast("Ocorreu um erro ao listar a renda. Tente novamente.", "danger", "Erro ao listar a renda", error);
        })
        .finally(() => (this.loading = false));
    },

    GetDataBorderColor (code) {
      switch (code) {
        case 1:
          return "rgba(0, 48, 77, 0.8)";
        case 2:
          return "rgba(90, 97, 105, 0.8)";
        case 3:
          return "rgba(10, 195, 127, 0.8)";
        case 4:
          return "rgba(81, 195, 100, 0.8)";
        case 5:
          return "rgba(203, 205, 61, 0.8)";
        case 6:
          return "rgba(0, 184, 216, 0.8)";
        case 7:
          return "rgba(255, 180, 0, 0.8)";
        case 8:
          return "rgba(150, 92, 174, 0.8)";
        case 9:
          return "rgba(234, 35, 77, 0.8)";
        case 10:
          return "rgba(33, 37, 41, 0.8)";
        case 11:
          return "rgba(255, 65, 105, 0.8)";
        case 12:
          return "rgba(103, 78, 236, 0.8)";
        case 13:
          return "rgba(26, 219, 162, 0.8)";
      }
    },

    GetDataColor (code) {
      switch (code) {
        case 1:
          return "rgba(0, 48, 77, 0.2)";
        case 2:
          return "rgba(90, 97, 105, 0.2)";
        case 3:
          return "rgba(10, 195, 127, 0.2)";
        case 4:
          return "rgba(81, 195, 100, 0.2)";
        case 5:
          return "rgba(203, 205, 61, 0.2)";
        case 6:
          return "rgba(0, 184, 216, 0.2)";
        case 7:
          return "rgba(255, 180, 0, 0.2)";
        case 8:
          return "rgba(150, 92, 174, 0.2)";
        case 9:
          return "rgba(234, 35, 77, 0.2)";
        case 10:
          return "rgba(33, 37, 41, 0.2)";
        case 11:
          return "rgba(255, 65, 105, 0.2)";
        case 12:
          return "rgba(103, 78, 236, 0.2)";
        case 13:
          return "rgba(26, 219, 162, 0.2)";
      }
    },
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/FinancialView/FinancialView.js